export default {
	SET_REVIEWS_SUCCESS: 'SET_REVIEWS_SUCCESS',

	START_FETCHING_REVIEWS: 'START_FETCHING_REVIEWS',
	STOP_FETCHING_REVIEWS: 'STOP_FETCHING_REVIEWS',

	SET_ERRORS_REVIEWS: 'SET_ERRORS_REVIEWS',
};